import React, { useEffect /*, useState */ } from 'react';
import { Route } from 'react-router-dom';
import WorkstationOverviewPage from '../Order/WorkstationOverviewPage';
import OrderHistoryPage from '../Order/OrderHistoryPage';
import OrderDetailPage from '../Order/OrderDetailPage';
import OrderOverviewPage from '../Order/OrderOverviewPage';
import SettingsPage from './SettingsPage';
import HeaderBar from '../../Shared/HeaderBar';
import { PrivateRoute } from '../../Pages/Auth/PrivateRoute';
import { makeStyles } from "@material-ui/core";
import NavDrawer from '../../Shared/NavDrawer';
import { drawerWidth } from '../../../Config/constants';
import QualityChecksPage from '../QualityCheck/QualityChecksPage';
import PlateSamplingPage from '../QualityCheck/PlateSamplingPage';
import LoginPage from "../Auth/LoginPage";
import { useHistory } from 'react-router-dom';
import { dataService } from '../../../Services/data.service';
import { toast } from 'react-toastify';
import PlanningPage from '../Planning/PlanningPage';
import DashboardPage from '../Dashboard/DashboardPage';
import DashboardOverviewPage from '../Dashboard/DashboardOverviewPage';

export default function IndexPage(props) {

  const classes = useStyles();

  let history = useHistory()

  useEffect((props) => {
    let mounted = true
    dataService.getRestrictions().then(restrictions => {
      if (mounted) {
        if (JSON.stringify(restrictions.body) !== JSON.stringify(props.workstation.restrictions)) {
          props.actions.setRestrictions(restrictions.body)
        }
      }
    }).catch((error) => { toast.error(error, { position: toast.POSITION.TOP_CENTER }) })

    dataService.getWorkingHours().then(workingHours => {
      if (mounted) {
        if (JSON.stringify(workingHours.body) !== JSON.stringify(props.workstation.workingHours)) {
          props.actions.setWorkingHours(workingHours.body)
        }
      }
    }).catch((error) => { toast.error(error, { position: toast.POSITION.TOP_CENTER }) })  

    dataService.getRestrictionTypes().then(types => {
      if (mounted) {
        if (JSON.stringify(types.body) !== JSON.stringify(props.workstation.restrictionTypes)) {
          props.actions.setRestrictionTypes(types.body)
        }
      }
    }).catch((error) => { toast.error(error, { position: toast.POSITION.TOP_CENTER }) })    

    return function cleanup() {

      mounted = false
    }
  }, []);

  let loggedIn = props.user.userToken !== (null || undefined || "");

  return (
    <div className={classes.root} style={{ backgroundImage: `url(${process.env.PUBLIC_URL}/img/bgr-logo.svg), linear-gradient(#EFEFEF,#FFFFFF)`, backgroundRepeat: "no-repeat", backgroundPosition: 'right bottom', backgroundSize: '40%,100%', position: "absolute", width: "100%", zIndex: "0" }}>


      {loggedIn ? <HeaderBar className={classes.headerBar} actions={props.actions} {...props}></HeaderBar> : <React.Fragment></React.Fragment>}
      {/* {loggedIn ? <BottomBar {...props} history={history}></BottomBar> : <React.Fragment></React.Fragment>} */}
      {loggedIn ? <NavDrawer actions={props.actions} {...props}></NavDrawer> : <React.Fragment></React.Fragment>}
      <main className={classes.content}>
        <div className={classes.container}>
          <div className={classes.background}>
            <Route path="/login" component={() => <LoginPage {...props} history={history} />} />
            <PrivateRoute user={props.user} path="/history" component={OrderHistoryPage} />
            <PrivateRoute user={props.user} path="/settings" component={() => <SettingsPage i18n={props.i18n} ></SettingsPage>} />
            <PrivateRoute user={props.user} path="/order/:id" component={(matchProps) => <OrderDetailPage {...matchProps} {...props} actions={props.actions}></OrderDetailPage>} />
            <PrivateRoute user={props.user} path="/sampling/:id/:barcode/:progress/:samplesTaken" component={(matchProps) => <PlateSamplingPage {...matchProps} {...props} actions={props.actions}></PlateSamplingPage>} />
            <PrivateRoute user={props.user} path="/qualitychecks/:progress/:id" component={(matchProps) => <QualityChecksPage {...matchProps} {...props} actions={props.actions} ></QualityChecksPage>} />
            <PrivateRoute user={props.user} path="/workstation" component={(matchProps) => <OrderOverviewPage {...matchProps}  {...props}></OrderOverviewPage>} />
            <PrivateRoute user={props.user} exact path="/" component={() => <WorkstationOverviewPage {...props} ></WorkstationOverviewPage>} />
            <PrivateRoute user={props.user} path="/dashboard/:id" component={(matchProps) => <DashboardPage {...matchProps}  {...props} actions={props.actions} history={history}></DashboardPage>} />
            <PrivateRoute user={props.user} exact path="/dashboardoverview" component={() => <DashboardOverviewPage {...props} actions={props.actions}></DashboardOverviewPage>} />   
            {props.workstation.workingHours && props.workstation.restrictionTypes ? <PrivateRoute user={props.user} exact path="/planning" component={() => <PlanningPage {...props} order={props.order} workstation={props.workstation} actions={props.actions}></PlanningPage>} /> : <React.Fragment></React.Fragment>}
          </div>
        </div>
      </main>
      <div className={classes.powered}>Powered by Flagstone</div>
    </div>
  )
}

const useStyles = makeStyles((theme) => ({
  container: {
    overflow: "auto",
  },
  backdrop: {
    zIndex: 100,
    color: '#fff'
  },
  background: {
    height: '100vh'
  },
  root: {
    display: 'flex',
  },
  appBar: {
    zIndex: theme.zIndex.drawer + 1,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
  },
  appBarShift: {
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  menuButton: {
    marginRight: 36,
  },
  hide: {
    display: 'none',
  },
  toolbar: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    padding: theme.spacing(0, 1),
    // necessary for content to be below app bar
    ...theme.mixins.toolbar,
  },
  content: {
    flexGrow: 1,
    width: "95%"
  },
  powered: {
    height: "20px",
    width: "150px",
    position: "absolute",
    bottom: "70",
    right: "40px",
    overflow: "hidden",
    fontSize: "14px",
    fontFamily: "Lato, sans-serif",
    fontWeight: 'Medium',
    color: "#E8E8E8",
    zIndex: "-1"
  }

}));